import Robot from "./Robot";

export { Robot };
